import { EFetchStatus } from '../../types/listingOffers';
import { IApplicationState } from '../../types/redux';

export const selectIsOffersLoaded = (state: IApplicationState) => {
  return state.listingOffers.status === EFetchStatus.SUCCESS;
};
